module.exports = "./img/d40e19f37396f3af844f6fe3059eb91f.jpg";